import { get } from "../../utils/objectHelpers";

$ {
    const title = get(input, "title", {});
    const sections = get(input, "sections", []);
}

<div class="str-business-details">
     <h2 class="str-business-details__title">
        <str-textual-display ...title />
    </h2>
    <div class="str-business-details__seller-info">
        <for|section| of=sections>
            $ {
                const title = get(section, "title", {});
                const action = get(section, "action", {});
            }
            <str-textual-display ...title action=action/>
        </for>
    </div>
</div>
